module.exports = __webpack_public_path__ + "static/media/bell.ae1bc939.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ChannelListItemActions/bell.svg
 ** module id = 616
 ** module chunks = 0
 **/